document.querySelectorAll('.newsletter-form').forEach((form) => {
  const modal = form.parentElement.querySelector('.newsletter-consent-modal');
  const consentInput = form.querySelector('[data-newsletter-consent-input]');
  const trigger = form.querySelector('[data-newsletter-consent-trigger]');
  const emailInput = form.querySelector('input[type="email"]');
  if (!modal || !consentInput || !trigger || !emailInput) return;

  const dialog = modal.querySelector('.newsletter-consent-modal__dialog');
  const acceptButton = modal.querySelector('[data-newsletter-consent-accept]');
  const declineButton = modal.querySelector('[data-newsletter-consent-decline]');
  let openedAt = 0;

  trigger.addEventListener('click', () => {
    if (!emailInput.reportValidity()) return;
    modal.hidden = false;
    openedAt = Date.now();
    dialog.focus();
  });

  acceptButton.addEventListener('click', () => {
    if (Date.now() - openedAt < 300) return;
    consentInput.value = '1';
    modal.hidden = true;
    form.requestSubmit();
  });

  declineButton.addEventListener('click', () => {
    if (Date.now() - openedAt < 300) return;
    modal.hidden = true;
  });
});
